import * as React from "react";

export const CardiometabolicSugarMetabolismKeyContent = () => (
  <>
    <g id="Key">
      <rect width={1024} height={244} fill="white" />
      <g id="Container_2">
        <g id="key-item - Gene">
          <rect x={40.5} y={66.5} width={318} height={149} stroke="#818181" />
          <text
            id="gene-label"
            fill="#1A1A1A"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Bold"
            fontSize={12}
            letterSpacing="2.8px"
          >
            <tspan x={52.4383} y={86.4}>
              GENETICS
            </tspan>
          </text>
          <g id="Container_3">
            <g id="Container_4">
              <g id="Container_5">
                <g id="Component 2">
                  <g id="gene-lozenge">
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      stroke="#1A1A1A"
                      strokeWidth={0.778643}
                    />
                  </g>
                </g>
                <text
                  id="Description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.0723} y={112.767}>
                    Not included in panel
                  </tspan>
                </text>
              </g>
              <g id="Container_6">
                <g id="Component 2_2">
                  <g id="gene-lozenge_2">
                    <path
                      d="M52 128C52 125.791 53.7909 124 56 124H72C74.2091 124 76 125.791 76 128V144C76 146.209 74.2091 148 72 148H56C53.7909 148 52 146.209 52 144V128Z"
                      fill="#CCBAFF"
                    />
                  </g>
                </g>
                <text
                  id="Description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2559} y={140.767}>
                    No read
                  </tspan>
                </text>
              </g>
              <g id="Container_7">
                <g id="Component 2_3">
                  <g id="snp-indicator">
                    <path
                      id="Polygon 3"
                      d="M63.3387 158.372C63.6326 157.876 64.3674 157.876 64.6613 158.372L70.8966 168.885C71.1905 169.381 70.8231 170 70.2352 170H57.7648C57.1769 170 56.8095 169.381 57.1034 168.885L63.3387 158.372Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.1738} y={168.767}>
                    Increased activity
                  </tspan>
                </text>
              </g>
              <g id="Container_8">
                <g id="Component 2_4">
                  <g id="snp-indicator_2">
                    <path
                      id="Polygon 3_2"
                      d="M64.6613 197.628C64.3674 198.124 63.6326 198.124 63.3387 197.628L57.1034 187.115C56.8095 186.619 57.1769 186 57.7648 186L70.2352 186C70.8231 186 71.1905 186.619 70.8966 187.115L64.6613 197.628Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_4"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2285} y={196.767}>
                    Decreased activity
                  </tspan>
                </text>
              </g>
            </g>
            <g id="Container_9">
              <g id="Container_10">
                <g id="Component 2_5">
                  <g id="gene-lozenge_3">
                    <path
                      d="M237 100C237 97.7909 238.791 96 241 96H257C259.209 96 261 97.7909 261 100V116C261 118.209 259.209 120 257 120H241C238.791 120 237 118.209 237 116V100Z"
                      fill="#00BF86"
                    />
                  </g>
                </g>
                <text
                  id="Risk description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.288} y={112.767}>
                    0 risk alleles
                  </tspan>
                </text>
              </g>
              <g id="Container_11">
                <g id="Component 2_6">
                  <g id="gene-lozenge_4">
                    <path
                      d="M237 128C237 125.791 238.791 124 241 124H257C259.209 124 261 125.791 261 128V144C261 146.209 259.209 148 257 148H241C238.791 148 237 146.209 237 144V128Z"
                      fill="#FF905F"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.271} y={140.767}>
                    1 risk allele
                  </tspan>
                </text>
              </g>
              <g id="Container_12">
                <g id="Component 2_7">
                  <g id="gene-lozenge_5">
                    <path
                      d="M237 156C237 153.791 238.791 152 241 152H257C259.209 152 261 153.791 261 156V172C261 174.209 259.209 176 257 176H241C238.791 176 237 174.209 237 172V156Z"
                      fill="#FF5D6D"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.006} y={168.767}>
                    2 risk alleles
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
        <g id="Container_13">
          <g id="key-item - Inhibitor">
            <g id="lines">
              <g id="Frame 481">
                <path id="Vector" d="M387.7 86V70" stroke="#E44C4B" strokeWidth={1.4} />
                <path id="Vector_2" d="M388.4 78L441 78" stroke="#E44C4B" strokeWidth={1.4} />
              </g>
            </g>
            <text
              id="Inhibitor"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={451.435} y={82.767}>
                Inhibitor
              </tspan>
            </text>
          </g>
          <g id="key-item - affect">
            <g id="lines_2">
              <path
                id="Vector_3"
                d="M532.7 77.3C532.314 77.3 532 77.6134 532 78C532 78.3866 532.314 78.7 532.7 78.7V78V77.3ZM587 78L580 73.9585V82.0415L587 78ZM534.639 78.7C535.026 78.7 535.339 78.3866 535.339 78C535.339 77.6134 535.026 77.3 534.639 77.3V78V78.7ZM538.518 77.3C538.131 77.3 537.818 77.6134 537.818 78C537.818 78.3866 538.131 78.7 538.518 78.7V78V77.3ZM542.397 78.7C542.783 78.7 543.097 78.3866 543.097 78C543.097 77.6134 542.783 77.3 542.397 77.3V78V78.7ZM546.275 77.3C545.889 77.3 545.575 77.6134 545.575 78C545.575 78.3866 545.889 78.7 546.275 78.7V78V77.3ZM550.154 78.7C550.54 78.7 550.854 78.3866 550.854 78C550.854 77.6134 550.54 77.3 550.154 77.3V78V78.7ZM554.032 77.3C553.646 77.3 553.332 77.6134 553.332 78C553.332 78.3866 553.646 78.7 554.032 78.7V78V77.3ZM557.911 78.7C558.298 78.7 558.611 78.3866 558.611 78C558.611 77.6134 558.298 77.3 557.911 77.3V78V78.7ZM561.789 77.3C561.403 77.3 561.089 77.6134 561.089 78C561.089 78.3866 561.403 78.7 561.789 78.7V78V77.3ZM565.668 78.7C566.055 78.7 566.368 78.3866 566.368 78C566.368 77.6134 566.055 77.3 565.668 77.3V78V78.7ZM569.547 77.3C569.16 77.3 568.847 77.6134 568.847 78C568.847 78.3866 569.16 78.7 569.547 78.7V78V77.3ZM573.425 78.7C573.812 78.7 574.125 78.3866 574.125 78C574.125 77.6134 573.812 77.3 573.425 77.3V78V78.7ZM577.304 77.3C576.917 77.3 576.604 77.6134 576.604 78C576.604 78.3866 576.917 78.7 577.304 78.7V78V77.3ZM581.182 78.7C581.569 78.7 581.882 78.3866 581.882 78C581.882 77.6134 581.569 77.3 581.182 77.3V78V78.7ZM585.061 77.3C584.674 77.3 584.361 77.6134 584.361 78C584.361 78.3866 584.674 78.7 585.061 78.7V78V77.3ZM532.7 78V78.7H534.639V78V77.3H532.7V78ZM538.518 78V78.7H542.397V78V77.3H538.518V78ZM546.275 78V78.7H550.154V78V77.3H546.275V78ZM554.032 78V78.7L557.911 78.7V78V77.3L554.032 77.3V78ZM561.789 78V78.7H565.668V78V77.3H561.789V78ZM569.547 78V78.7H573.425V78V77.3H569.547V78ZM577.304 78V78.7H581.182V78V77.3H577.304V78Z"
                fill="#1A1A1A"
              />
            </g>
            <text
              id="Affect"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={597.484} y={82.767}>
                Negative feedback
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </>
);

const SvgCardiometabolicSugarMetabolismKey = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={244}
    viewBox="0 0 1024 244"
    fill="none"
    {...props}
  >
    <CardiometabolicSugarMetabolismKeyContent />
  </svg>
);

export default SvgCardiometabolicSugarMetabolismKey;
